var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$store.state.loading
        ? _c("loading-anim", {
            attrs: { active: _vm.$store.state.loading, fullScreen: "" }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-navbar",
        {
          staticClass: "os-navbar",
          class: { "fixed-scroll": _vm.isFixedScrolled },
          attrs: { toggleable: _vm.isToggleable }
        },
        [
          _c(
            "b-navbar-toggle",
            { attrs: { id: "navbar-toggler", target: "nav-collapse" } },
            [
              _c("base-icon", {
                style: { color: _vm.color },
                attrs: {
                  src:
                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/menu-icon.svg",
                  color: _vm.color,
                  width: _vm.iconSize,
                  height: _vm.iconSize
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-collapse",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.hideMenu,
                  expression: "hideMenu"
                }
              ],
              attrs: { id: "nav-collapse", "is-nav": "" },
              model: {
                value: _vm.collapseVisible,
                callback: function($$v) {
                  _vm.collapseVisible = $$v
                },
                expression: "collapseVisible"
              }
            },
            [
              _c(
                "b-navbar-nav",
                { staticClass: "ml-0 ml-desktop-auto ml-xl-auto" },
                [
                  _c(
                    "b-nav-item",
                    { staticClass: "mr-0 mr-lg-2" },
                    [_c("lang-selector", { attrs: { enablePortuguese: "" } })],
                    1
                  ),
                  _vm._v(" "),
                  _vm._t("nav-items"),
                  _vm._v(" "),
                  _vm._t("nav-btn-items")
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-navbar-brand", { attrs: { href: "/" } }, [
            _c("img", {
              class: _vm.getLogoClasses,
              style: _vm.getLogoStyles,
              attrs: { src: _vm.getLogo }
            })
          ]),
          _vm._v(" "),
          _c(
            "b-nav-item",
            { staticClass: "d-xl-none d-desktop-none d-block" },
            [
              _c(
                "button",
                {
                  staticClass: "navbar-toggler",
                  on: {
                    click: function($event) {
                      return _vm.$router.push("/inicio-sesion")
                    }
                  }
                },
                [
                  _c("base-icon", {
                    attrs: {
                      src:
                        "/static-appopensalud/img/icons/morillas-svg-icons/primary/profile.svg",
                      color: _vm.color,
                      width: _vm.iconSize,
                      height: _vm.iconSize
                    }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm._t("heading"),
          _vm._v(" "),
          !_vm.showTabContent || !_vm.$uiHelpers.isXlDevice
            ? _c("router-view", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var Component = ref.Component
                        return [
                          _c(
                            "transition",
                            { attrs: { name: "fade", mode: "out-in" } },
                            [_c(Component, { tag: "component" })],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  2832544733
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showInstallAppButton
            ? _c("AddToHomeScreen", {
                staticClass: "add-to-home-screen",
                attrs: { animate: "", shadow: "" }
              })
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-235e2044", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-235e2044","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/PublicMenuLayoutV2.vue
// module id = 2022
// module chunks = 116